/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ProjectFundingReferenceFundingStreamDTO
 */
export interface ProjectFundingReferenceFundingStreamDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectFundingReferenceFundingStreamDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectFundingReferenceFundingStreamDTO
     */
    fundingStream?: string;
}

/**
 * Check if a given object implements the ProjectFundingReferenceFundingStreamDTO interface.
 */
export function instanceOfProjectFundingReferenceFundingStreamDTO(value: object): value is ProjectFundingReferenceFundingStreamDTO {
    return true;
}

export function ProjectFundingReferenceFundingStreamDTOFromJSON(json: any): ProjectFundingReferenceFundingStreamDTO {
    return ProjectFundingReferenceFundingStreamDTOFromJSONTyped(json, false);
}

export function ProjectFundingReferenceFundingStreamDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectFundingReferenceFundingStreamDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'fundingStream': json['fundingStream'] == null ? undefined : json['fundingStream'],
    };
}

export function ProjectFundingReferenceFundingStreamDTOToJSON(json: any): ProjectFundingReferenceFundingStreamDTO {
    return ProjectFundingReferenceFundingStreamDTOToJSONTyped(json, false);
}

export function ProjectFundingReferenceFundingStreamDTOToJSONTyped(value?: ProjectFundingReferenceFundingStreamDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fundingStream': value['fundingStream'],
    };
}


